import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-2',
  templateUrl: './cards-2.component.html'
})
export class Cards2Component {




    }
